import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Input, Typography } from "antd";

const props = {
    text: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

const InputSection = ({ text, onChange }) => {
    const { t } = useTranslation();

    return (
        <section className="input-section mb-2">
            <Typography.Text type="secondary" className="mr-2">
                {t("name")}:
            </Typography.Text>
            <Input maxLength={25} allowClear value={text} onChange={(e) => onChange(e.target.value)} />
        </section>
    );
};

InputSection.propTypes = props;

export default InputSection;
